<template>
  <el-card
    id="platformSettings"
    v-loading="loading"
    shadow="hover"
    :body-style="{padding: '20px 30px 30px'}"
    class="mainCard clear-card"
  >
    <div class="title">
      <div class="left defaultCursor">
        {{ $t('settings.platformSettings') }}
      </div>
      <div class="right">
        <el-button
          :type="edit ? 'plain' : 'primary'"
          round
          @click="clickEdit"
        >
          <span v-if="!edit">
            {{ $t('common.edit') }} <i class="el-icon-edit"></i>
          </span>
          <span v-else>
            {{ $t('common.save') }}
          </span>
        </el-button>
      </div>
    </div>

    <div class="content">
      <el-form
        ref="settingsForm"
        :model="form"
      >
        <el-row :gutter="20">
          <el-col :span="responsiveCol">
            <div class="videoLink">
              <div class="title">
                {{ $t('settings.videoConferencingLink') }}
              </div>
            </div>
            <el-form-item :error="error.meeting_link[0]">
              <el-input
                v-show="edit || form.meeting_link"
                v-model="form.meeting_link"
                :class="edit ? 'line' : 'noLine'"
                :disabled="!edit"
                :suffix-icon="edit ? 'el-icon-edit' : ''"
                @focus="error.meeting_link = []"
                @keyup.native.enter="saveSettings"
              />
              <div v-show="!edit && !form.meeting_link">
                -
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="responsiveCol">
            <div class="maximumEngagement">
              <div class="title">
                {{ $t('settings.maximumEngagements') }}
              </div>
            </div>
            <el-form-item :error="error.maximumEngagements[0]">
              <el-input
                v-show="edit || form.maximumEngagements"
                v-model="form.maximumEngagements"
                :class="edit ? 'line' : 'noLine'"
                :disabled="!edit"
                :suffix-icon="edit ? 'el-icon-edit' : ''"
                type="number"
                @focus="error.maximumEngagements = []"
              />
              <div v-show="!edit && !form.maximumEngagements">
                -
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import api from '@/api';

export default {
  name: 'PlatformSettings',

  data: () => ({
    loading: false,
    form: {
      meeting_link: '',
      maximumEngagements: 0,
    },
    error: {
      meeting_link: [],
      maximumEngagements: [],
    },
    edit: false,
  }),

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    responsiveCol() {
      let col = 12;
      if (this.$mq === 'mobile') {
        col = 24;
      }
      return col;
    },
  },

  created() {
    this.initForm(this.user);
  },

  methods: {
    ...mapMutations('user', [
      'loginUser',
    ]),

    initForm(data) {
      const tier3 = data.profile.display_tier_list.find((el) => el.tier === 3);
      this.form.meeting_link = data.profile.meeting_link;
      this.form.maximumEngagements = tier3 ? tier3.max_engagement_ct : 0;
    },

    async clickEdit() {
      if (this.edit) {
        await this.saveSettings();
      } else {
        this.edit = !this.edit;
      }
    },

    async saveSettings() {
      try {
        this.loading = true;

        const data = {
          profile: {
            meeting_link: this.form.meeting_link,
            display_tier_list: [{
              max_engagement_ct: this.form.maximumEngagements,
              tier: 3,
            }],
          },
        };

        const response = await api.updateUserProfile(data);
        this.$message.success(this.$t('settings.alert.settingsSaved'));
        this.initForm(response.data);
        await this.loginUser(response.data);
        this.edit = false;
      } catch (err) {
        console.log(err);
        if (err.field) {
          const { field } = err;
          Object.keys(field).forEach((key) => {
            if (key in this.error) {
              this.error[key] = field[key];
            }
          });
        }
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#platformSettings {
  margin-bottom: 20px;

  .title {
    margin-bottom: 20px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: default;

    .left {
      font-size: 16px;
    }
  }

  .el-row:not(:last-child) {
    margin-bottom: 20px;

    &.firstRow {
      margin-bottom: 70px;
    }
  }

  .viewBtnWrap {
    margin: 18px 0 0;

    .viewBtn {
      background: transparent;
      color: white;
    }
  }

  .warning {
    color: #f56c6c;
    font-size: 14px;
  }
}
</style>
